import { render, staticRenderFns } from "./personEnter.vue?vue&type=template&id=87701894&scoped=true&"
import script from "./personEnter.vue?vue&type=script&lang=js&"
export * from "./personEnter.vue?vue&type=script&lang=js&"
import style0 from "./personEnter.vue?vue&type=style&index=0&id=87701894&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87701894",
  null
  
)

export default component.exports